import { appT } from '~/composables/useAppI18n';

const PREFIX = 'hrEvaluation.conf.settings';
const BASIS_COMMON_PREFIX = 'hrEvaluation.conf.basis.common';
const TARGETS_PREFIX = 'hrEvaluation.conf.targets';

/** store·비동기 handler */
export const settingsT = (key: string, params?: Record<string, unknown>) => {
  if (key.startsWith('basisCommon.')) {
    const basisKey = `${BASIS_COMMON_PREFIX}.${key.slice('basisCommon.'.length)}`;
    const basisTranslated = appT(basisKey, params);
    if (basisTranslated !== basisKey) {
      return basisTranslated;
    }
  }
  if (key.startsWith('targets.')) {
    const targetKey = `${TARGETS_PREFIX}.${key.slice('targets.'.length)}`;
    const targetTranslated = appT(targetKey, params);
    if (targetTranslated !== targetKey) {
      return targetTranslated;
    }
  }
  const fullKey = key.startsWith(`${PREFIX}.`) ? key : `${PREFIX}.${key}`;
  const translated = appT(fullKey, params);
  if (translated !== fullKey) {
    return translated;
  }
  if (key.startsWith('common.')) {
    const rootTranslated = appT(key, params);
    if (rootTranslated !== key) {
      return rootTranslated;
    }
  }
  return translated;
};

export const useHrEvalSettingsI18n = () => {
  const { locale, t } = useI18n();

  const st = (key: string, params?: Record<string, unknown>) => {
    locale.value;
    return settingsT(key, params);
  };

  return { locale, t, st, settingsT: st };
};
